/**
 * Utility function to safely extract error messages from API responses
 * Handles different error formats including Pydantic validation errors
 */
export const getErrorMessage = (error, defaultMessage = 'An error occurred') => {
  // If error is already a string, return it
  if (typeof error === 'string') {
    return error;
  }

  // Check for axios response error structure
  if (error?.response?.data) {
    const data = error.response.data;
    
    // Handle string detail
    if (typeof data.detail === 'string') {
      return data.detail;
    }
    
    // Handle Pydantic validation errors (array format)
    if (Array.isArray(data.detail)) {
      return data.detail.map(err => {
        if (typeof err === 'string') return err;
        if (err.msg) return err.msg;
        if (err.message) return err.message;
        return JSON.stringify(err);
      }).join(', ');
    }
    
    // Handle other message formats
    if (data.message && typeof data.message === 'string') {
      return data.message;
    }
    
    // Handle error field
    if (data.error && typeof data.error === 'string') {
      return data.error;
    }
  }

  // Check for direct error message
  if (error?.message && typeof error.message === 'string') {
    return error.message;
  }

  // Return default message if nothing else works
  return defaultMessage;
};

/**
 * Utility function to safely render error messages in React components
 * Ensures objects are not rendered directly as React children
 */
export const renderErrorMessage = (error, defaultMessage = 'An error occurred') => {
  const message = getErrorMessage(error, defaultMessage);
  return typeof message === 'string' ? message : defaultMessage;
};